import React from 'react';
import CSSModules from 'react-css-modules';
import {FormattedMessage} from 'react-intl';
import contactUsUrl from 'utils/url/contactUsUrl';
import faqUrl from 'utils/url/faqUrl';
import termsOfUseUrl from 'utils/url/termsOfUseUrl';
import privacyAgreementUrl from 'utils/url/privacyAgreement';
import glbaUrl from 'utils/url/glba';
import glbaTabUrl from 'utils/url/glbaTab';
import styles from './Footer.scss';


@CSSModules(styles, {allowMultiple: true})
class TopBar extends React.Component {
  render() {
    return (
      <footer styleName="footerLinks">
        <a data-at="contactUsBtn" styleName="link" href={contactUsUrl()} target="_blank"><FormattedMessage id="common.link.contactUs.text.capitalized" /></a>
        <a data-at="faqBtn" styleName="link" href={faqUrl()} target="_blank"><FormattedMessage id="common.link.faq.text" /></a>
        <a data-at="termsOfUseBtn" styleName="link" href={termsOfUseUrl()} target="_blank"><FormattedMessage id="common.link.termsOfUse.text" /></a>
        <a data-at="privacyBtn" styleName="link" href={privacyAgreementUrl()} target="_blank"><FormattedMessage id="common.link.privacyAgreement.text" /></a>
        <a data-at="glbaBtn" styleName="link" href={glbaUrl()} target="_blank"><FormattedMessage id="common.link.glba.text" /></a>
        <a data-at="glbaTabBtn" styleName="link" href={glbaTabUrl()} target="_blank"><FormattedMessage id="common.link.glbaTab.text" /></a>
      </footer>
    );
  }
}

export default TopBar;



// WEBPACK FOOTER //
// ./src/root/Footer.js